export default __webpack_public_path__ + "static/media/electronics.af33ccbd.jpeg";